export function formatPriceValue(priceValue) {
  return String(priceValue)
    .split("")
    .reverse()
    .join("")
    .replace(/(\d{3})/g, "$1 ")
    .split("")
    .reverse()
    .join("")
    .replace(/^ /, "")
    .split(".")[0];
}

export function formatPrice(priceValue, options = {}) {
  const { withCurrency = false, fallback = "" } = options;

  if (priceValue === null || priceValue === undefined || priceValue === "") {
    return fallback;
  }

  const formatted = formatPriceValue(priceValue);
  return withCurrency ? `${formatted} ₽` : formatted;
}
